// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"f3460808","579":"4f7df5dd","593":"ee1e43db","672":"79fd5641","764":"c159ee54","848":"c242817a"}[chunkId] + ".chunk.css";
};